import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import {
  ApexAxisChartSeries,
  ApexChart,
  ApexStroke,
  ApexDataLabels,
  ApexXAxis,
  ApexGrid,
  ApexTitleSubtitle,
  ApexTooltip,
  ApexPlotOptions,
  ApexYAxis,
  ApexFill,
  ApexMarkers,
  ApexTheme,
  ApexNonAxisChartSeries,
  ApexLegend,
  ApexResponsive,
  ApexStates
} from 'ng-apexcharts';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { colors } from 'app/colors.const';
import { CoreConfigService } from '@core/services/config.service';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../services/Api/api.service';
import { ExcelService } from 'app/services/Excel/excel.service';

export interface ChartOptions {
  series?: ApexAxisChartSeries;
  chart?: ApexChart;
  xaxis?: ApexXAxis;
  dataLabels?: ApexDataLabels;
  grid?: ApexGrid;
  stroke?: ApexStroke;
  legend?: ApexLegend;
  title?: ApexTitleSubtitle;
  colors?: string[];
  tooltip?: ApexTooltip;
  plotOptions?: ApexPlotOptions;
  yaxis?: ApexYAxis;
  fill?: ApexFill;
  labels?: string[];
  markers: ApexMarkers;
  theme: ApexTheme;
}
export interface ChartOptions2 {
  series?: ApexNonAxisChartSeries;
  chart?: ApexChart;
  stroke?: ApexStroke;
  tooltip?: ApexTooltip;
  dataLabels?: ApexDataLabels;
  fill?: ApexFill;
  colors?: string[];
  legend?: ApexLegend;
  labels?: any;
  plotOptions?: ApexPlotOptions;
  responsive?: ApexResponsive[];
  markers?: ApexMarkers[];
  xaxis?: ApexXAxis;
  yaxis?: ApexYAxis;
  states?: ApexStates;
}

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  @ViewChild('apexDonutChartRef') apexDonutChartRef: any;
  @ViewChild('apexColumnChartRef') apexColumnChartRef: any;
  public apexDonutChart: Partial<ChartOptions2> = {};
  public apexColumnChart: Partial<ChartOptions>;
  public isMenuToggled = false;

  calendarIcon: SafeHtml;
  usersIcon: SafeHtml;
  ticketsIcon: SafeHtml;
  salesIcon: SafeHtml;
  
  totalPayment: number = 0;
  availableTickets: number = 0;
  purchasedTickets: number = 0;

  totalEvents: number = 0;
  totalTicketsSold: number = 0;
  totalOrganizers: number = 0;
  totalUsers: number = 0;

    public paymentsData: any[] = [];
    public eventsData: any[] = [];
    public usersData: any[] = [];
    public ticketsData: any[] = [];
    public categories: string[] = [];

  public paymentStatus = [
    {
      paymentStatus: 'Success',
      id: '1'
    },
    {
      paymentStatus: 'Failed',
      di: '2'
    }
  ]

  public paymentWay = [
    {
      paymentWay: 'Credit Card',
      id: '1'
    },
    {
      paymentWay: 'Debit Card',
      di: '2'
    }
  ]
  // Color Variables
  chartColors = {
    column: {
      series1: '#3F8260',
      bg: '#f0f8ff00'
    },
    success: {
      shade_100: '#7eefc7',
      shade_200: '#06774f'
    },
    donut: {
      series1: '#24B364',
      series2: '#FF9F43'
    },
    area: {
      series3: '#a4f8cd',
      series2: '#60f2ca',
      series1: '#2bdac7'
    }
  };

  constructor(private _coreConfigService: CoreConfigService, private sanitizer: DomSanitizer,
    private modalService: NgbModal, private api: ApiService,private excelService: ExcelService) {
    this.calendarIcon = this.sanitize(`
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="4" y="5" width="16" height="16" rx="2" stroke="#28C76F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M16 3V7" stroke="#28C76F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M8 3V7" stroke="#28C76F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M4 11H20" stroke="#28C76F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <rect x="8" y="15" width="2" height="2" stroke="#28C76F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`);

    this.usersIcon = this.sanitize(`
      <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="9.5" cy="7" r="4" stroke="#00BAD1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M3.5 21V19C3.5 16.7909 5.29086 15 7.5 15H11.5C13.7091 15 15.5 16.7909 15.5 19V21" stroke="#00BAD1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M16.5 3.12988C18.2699 3.58305 19.5078 5.17787 19.5078 7.00488C19.5078 8.83189 18.2699 10.4267 16.5 10.8799" stroke="#00BAD1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M21.5 20.9999V18.9999C21.4896 17.1845 20.2578 15.6037 18.5 15.1499" stroke="#00BAD1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>`);

    this.ticketsIcon = this.sanitize(`
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 5V7" stroke="#3F8260" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M15 11V13" stroke="#3F8260" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M15 17V19" stroke="#3F8260" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M5 5H19C20.1046 5 21 5.89543 21 7V10C19.8954 10 19 10.8954 19 12C19 13.1046 19.8954 14 21 14V17C21 18.1046 20.1046 19 19 19H5C3.89543 19 3 18.1046 3 17V14C4.10457 14 5 13.1046 5 12C5 10.8954 4.10457 10 3 10V7C3 5.89543 3.89543 5 5 5" stroke="#3F8260" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>`);

    this.salesIcon = this.sanitize(`
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15.0007 8.33325H11.6673C9.82637 8.33325 8.33398 9.82564 8.33398 11.6666V31.6666C8.33398 33.5075 9.82637 34.9999 11.6673 34.9999H28.334C30.1749 34.9999 31.6673 33.5075 31.6673 31.6666V11.6666C31.6673 9.82564 30.1749 8.33325 28.334 8.33325H25.0007" stroke="#24B364" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <rect x="15" y="5" width="10" height="6.66667" rx="2" stroke="#24B364" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M23.3327 18.3333H19.166C17.7853 18.3333 16.666 19.4525 16.666 20.8333C16.666 22.214 17.7853 23.3333 19.166 23.3333H20.8327C22.2134 23.3333 23.3327 24.4525 23.3327 25.8333C23.3327 27.214 22.2134 28.3333 20.8327 28.3333H16.666" stroke="#24B364" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M20.7493 28.3334C20.7493 27.9192 20.4136 27.5834 19.9993 27.5834C19.5851 27.5834 19.2493 27.9192 19.2493 28.3334H20.7493ZM19.2493 30.0001C19.2493 30.4143 19.5851 30.7501 19.9993 30.7501C20.4136 30.7501 20.7493 30.4143 20.7493 30.0001H19.2493ZM20.7493 16.6667C20.7493 16.2525 20.4136 15.9167 19.9993 15.9167C19.5851 15.9167 19.2493 16.2525 19.2493 16.6667H20.7493ZM19.2493 18.3334C19.2493 18.7476 19.5851 19.0834 19.9993 19.0834C20.4136 19.0834 20.7493 18.7476 20.7493 18.3334H19.2493ZM19.2493 28.3334V30.0001H20.7493V28.3334H19.2493ZM19.2493 16.6667V18.3334H20.7493V16.6667H19.2493Z" fill="#24B364"/>
      </svg> `);    
  }

  private toArray(value: any): any[] {
    if (Array.isArray(value)) {
      return value;
    }

    if (Array.isArray(value?.data)) {
      return value.data;
    }

    return [];
  }

  private toNumber(value: any): number {
    const numericValue = Number(value);
    return Number.isFinite(numericValue) ? numericValue : 0;
  }

  private getFirstNumber(source: any, keys: string[]): number {
    for (const key of keys) {
      if (source && source[key] !== undefined && source[key] !== null) {
        return this.toNumber(source[key]);
      }
    }

    return 0;
  }

  private createDefaultMonthlyStats() {
    const now = new Date();

    return {
      month: now.getMonth() + 1,
      year: now.getFullYear(),
      totalPayments: 0,
      totalSaledTickets: 0,
      totalEvents: 0,
      totalUsers: 0
    };
  }

  private getMonthKey(item: any): string {
    const now = new Date();
    const year = this.toNumber(item?.year) || now.getFullYear();
    const month = this.toNumber(item?.month) || now.getMonth() + 1;
    return `${year}-${month}`;
  }

  private getMonthLabel(monthYear: string): string {
    const [year, month] = monthYear.split('-');
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const monthIndex = this.toNumber(month) - 1;
    return `${monthNames[monthIndex] || 'N/A'} ${year || ''}`.trim();
  }

   drawPieChart() {
    this.purchasedTickets = this.toNumber(this.purchasedTickets);
    this.availableTickets = this.toNumber(this.availableTickets);

    this.apexDonutChart = {
      series: [this.purchasedTickets, this.availableTickets],
      chart: {
        height: 350,
        type: 'donut'
      },
      colors: [
        this.chartColors.donut.series1,
        this.chartColors.donut.series2
      ],
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: true,
              name: {
                fontSize: '2rem',
                fontFamily: '"Almarai", serif'
              },
              value: {
                fontSize: '1rem',
                fontFamily: '"Almarai", serif',
                formatter: function (val) {
                  return val;
                }
              },
              total: {
                show: true,
                fontSize: '1.5rem',
                label: 'اجمالي التذاكر',
                formatter: (w) => {
                  const total = this.toNumber(this.purchasedTickets) + this.toNumber(this.availableTickets);
                  return total.toLocaleString();
                }
              }
            }
          }
        }
      },
      legend: {
        show: true,
        position: 'bottom'
      },
      labels: ['التذاكر المباعة', 'التذاكر المتبقية'],
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              height: 300
            },
            legend: {
              position: 'bottom'
            }
          }
        }
      ]
    };
  }

  drawColumnChart() {
    const safePaymentsData = this.paymentsData.length ? this.paymentsData.map(item => this.toNumber(item)) : [0];
    const safeCategories = this.categories.length ? this.categories : [this.getMonthLabel(this.getMonthKey(this.createDefaultMonthlyStats()))];

    this.apexColumnChart = {
      series: [
        {
          name: 'المبيعات',
          data: safePaymentsData
        }
      ],
      chart: {
        type: 'bar',
        height: 400,
        stacked: true,
        toolbar: {
          show: false
        }
      },
      // ... rest of your chart config ...
      xaxis: {
        categories: safeCategories
      },
      legend: {
        show: true,
        position: 'top',
        horizontalAlign: 'left'
      },
       plotOptions: {
        bar: {
          columnWidth: '30%',
          colors: {
            backgroundBarColors: [
              this.chartColors.column.bg,
              this.chartColors.column.bg,
              this.chartColors.column.bg,
              this.chartColors.column.bg,
              this.chartColors.column.bg
            ],
            backgroundBarRadius: 10,
          }
        }
      },
      colors: [this.chartColors.column.series1],
      dataLabels: {
        enabled: false
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
      },
      fill: {
        opacity: 1
      },
      tooltip:{
        enabled: true,
        x: {
          show: false,
        },
        style: {
          fontSize: '12px',
          fontFamily: 'Almarai, Arial, sans-serif'
        }
      }
      // ... rest of your chart config ...
    };
  }

  updateColumnChartData(newData: number[], seriesName: string) {
    if (!this.apexColumnChart) {
      this.drawColumnChart();
    }

    const safeData = Array.isArray(newData) && newData.length ? newData.map(item => this.toNumber(item)) : [0];

    this.apexColumnChart.series = [{
      name: seriesName,
      data: safeData
    }];
    
    // Force chart update
    if (this.apexColumnChartRef) {
      this.apexColumnChartRef.updateSeries([{
        name: seriesName,
        data: safeData
      }]);
    }
  }

  sanitize(svg: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(svg);
  }

  public contentHeader: object;

  public readonly pageLimitOptions = [
    {value: 5},
    {value: 10},
    {value: 25},
    {value: 50},
    {value: 100},
  ];
  public currentVisible: number = 3;
  public currentPageLimit: number = 10;
  rows = [];
  temp = [];
  @ViewChild(DatatableComponent) public table: DatatableComponent;
  ColumnMode = ColumnMode;
  columns = []
  updateFilter(event: any) {
    const val = event?.target?.value ? event.target.value.toLowerCase() : '';
  
    // Filter data by checking all columns
    const temp = this.temp.filter((row) => {
      return Object.keys(row).some((key) => 
        row[key]?.toString().toLowerCase().includes(val)
      );
    });
  
    // Update the rows
    this.rows = temp;
  
    // Reset to first page
    if (this.table) {
      this.table.offset = 0;
    }
  }  
  public onLimitChange(limit: any): void {
    this.changePageLimit(limit);
    this.table.limit = this.currentPageLimit;
    this.table.recalculate();
    setTimeout(() => {
      if (this.table.bodyComponent.temp.length <= 0) {
        // TODO[Dmitry Teplov] find a better way.
        // TODO[Dmitry Teplov] test with server-side paging.
        this.table.offset = Math.floor((this.table.rowCount - 1) / this.table.limit);
        // this.table.offset = 0;
      }
    });
  }
  private changePageLimit(limit: any): void {
    this.currentPageLimit = parseInt(limit, 10);
  }
  public onVisibleChange(visible: any): void {
    this.currentVisible = parseInt(visible, 10);
  }


  ngOnInit() {
    document.getElementById('الفعاليات')?.classList.remove('active')
    document.getElementById('المشرفين')?.classList.remove('active')
    document.getElementById('المستخدمين')?.classList.remove('active')
    document.getElementById('طلبات المشرفين')?.classList.remove('active')
    document.getElementById('فئات المناسبات')?.classList.remove('active')
    // document.getElementById('الإشعارات')?.classList.remove('active')
    document.getElementById('العروض')?.classList.remove('active')
    this.columns = [
      { prop: '#' },
      { prop: 'paymentId', name: 'Payment ID' },
      { prop: 'orderId', name: 'Order ID' },
      { prop: 'totalAmount', name: 'Total Amount' },
      { prop: 'paymentWay', name: 'Payment Provider' },
      { prop: 'paymentStatus', name: 'Payment Status' },
      { prop: 'paidAt', name: 'Paid At' },
    ]
    this.api.getPaymentReports().subscribe({
      next: (response) => {
        this.rows = this.normalizePaymentReports(this.toArray(response?.data));
        this.temp = this.rows
      }
    });
    this.contentHeader = {
      headerTitle: 'الرئيسية',
      actionButton: true,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'الرئيسية',
            isLink: true,
            link: '/'
          }
        ]
      }
    };

    this.api.getTotalPayment().subscribe({
      next: (response) => {
        this.totalPayment = this.getFirstNumber(response?.data, ['totalAmount', 'amount', 'totalPayment', 'total']);
      }
    });

    this.api.getPaidRemainingTickets().subscribe({
      next: (response) => {
        const data = response?.data || {};
        const totalTicketsCount = this.getFirstNumber(data, ['totalTicketsCount', 'totalTickets', 'total']);
        this.availableTickets = this.getFirstNumber(data, ['availableTickets', 'remainingTickets']);
        this.purchasedTickets = this.getFirstNumber(data, ['purchasedTickets', 'paidTickets', 'soldTickets']);

        if (!this.availableTickets && !this.purchasedTickets && totalTicketsCount) {
          this.availableTickets = totalTicketsCount;
        }

        this.drawPieChart();
      }
    });

    this.api.getStatisticsPerLastYear().subscribe({
      next: (response) => {
        const data = Array.isArray(response?.data) ? response.data[0] || {} : response?.data || {};
        this.totalEvents = this.getFirstNumber(data, ['totalEvents']);
        this.totalTicketsSold = this.getFirstNumber(data, ['totalTicketsSold', 'totalSaledTickets', 'soldTickets']);
        this.totalOrganizers = this.getFirstNumber(data, ['totalOrganizers']);
        this.totalUsers = this.getFirstNumber(data, ['totalUsers']);
      }
    });

    this.api.getStatisticsOfLastMonths().subscribe({
      next: (response) => {
        // console.log(response.data)
        this.processApiData(response.data);
        this.drawColumnChart();
      }
    });
  }

  private processApiData(data: any) {
    const monthlyRows = this.toArray(data);
    const paymentsForMonths = this.toArray(data?.paymentsForMonths).length
      ? this.toArray(data?.paymentsForMonths)
      : monthlyRows;
    const eventsStatistics = this.toArray(data?.eventsStatistics).length
      ? this.toArray(data?.eventsStatistics)
      : monthlyRows;
    const usersStatistics = this.toArray(data?.usersStatistics).length
      ? this.toArray(data?.usersStatistics)
      : monthlyRows;
    const fallbackRows = monthlyRows.length || paymentsForMonths.length || eventsStatistics.length || usersStatistics.length
      ? []
      : [this.createDefaultMonthlyStats()];

    const safePaymentsForMonths = paymentsForMonths.length ? paymentsForMonths : fallbackRows;
    const safeEventsStatistics = eventsStatistics.length ? eventsStatistics : fallbackRows;
    const safeUsersStatistics = usersStatistics.length ? usersStatistics : fallbackRows;

    this.paymentsData = safePaymentsForMonths.map(item => this.getFirstNumber(item, ['totalPayments', 'totalAmount', 'payments']));
    this.ticketsData = safePaymentsForMonths.map(item => this.getFirstNumber(item, ['totalSaledTickets', 'totalTicketsSold', 'soldTickets']));
    this.eventsData = safeEventsStatistics.map(item => this.getFirstNumber(item, ['totalEvents', 'events']));

    const allMonths = [...new Set([
      ...safePaymentsForMonths.map(item => this.getMonthKey(item)),
      ...safeEventsStatistics.map(item => this.getMonthKey(item)),
      ...safeUsersStatistics.map(item => this.getMonthKey(item))
    ])].sort();
    
    this.usersData = allMonths.map(monthYear => {
      const found = safeUsersStatistics.find(item => 
        this.getMonthKey(item) === monthYear
      );
      return found ? this.getFirstNumber(found, ['totalUsers', 'users']) : 0;
    });
    
    this.categories = allMonths.map(monthYear => this.getMonthLabel(monthYear));
  }

  private normalizePaymentReports(items: any[]): any[] {
    return items.map((item, index) => ({
      '#': index + 1,
      paymentId: item.paymentId ?? item.id ?? '',
      orderId: item.orderId ?? item.invoiceId ?? '',
      totalAmount: this.getFirstNumber(item, ['amount', 'totalAmount', 'total']),
      paymentWay: item.provider ?? item.paymentWay ?? '',
      paymentStatus: item.status ?? item.paymentStatus ?? '',
      paidAt: item.paidAt ?? item.createdAt ?? item.created_At ?? '',
      providerPaymentId: item.providerPaymentId ?? '',
    }));
  }

  ngAfterViewInit() {
    // this._coreConfigService.getConfig().subscribe(config => {
    //   if (config.layout.menu.collapsed === true || config.layout.menu.collapsed === false) {
    //     setTimeout(() => {
    //       this.isMenuToggled = true;
    //       this.apexColumnChart.chart.width = this.apexColumnChartRef?.nativeElement.offsetWidth;
    //       this.apexDonutChart.chart.width = this.apexDonutChartRef?.nativeElement.offsetWidth;
    //     }, 900);
    //   }
    // });
  }

   onTabChange(tabTitle: string) {
    switch (tabTitle) {
      case 'الأحداث':
        this.updateColumnChartData(this.eventsData, 'الأحداث');
        break;
      case 'المستخدمين':
        this.updateColumnChartData(this.usersData, 'المستخدمين');
        break;
      case 'التذاكر':
        this.updateColumnChartData(this.ticketsData, 'التذاكر');
        break;
      case 'المبيعات':
        this.updateColumnChartData(this.paymentsData, 'المبيعات');
        break;
    }
  }

  // loadEvents() {
  //   const newData = [23, 23, 23, 23, 15, 30, 35, 28, 8]
  //   this.updateColumnChartData(newData);
  //   console.log('Loading Events Data...');
  // }

  // loadUsers() {
  //   const newData = [10, 10, 10, 38, 15, 30, 35, 28, 8]
  //   this.updateColumnChartData(newData);
  //   console.log('Loading Users Data...');
  // }

  // loadTickets() {
  //   const newData = [55, 55, 55, 38, 15, 30, 35, 28, 8]
  //   this.updateColumnChartData(newData);
  //   console.log('Loading Tickets Data...');
  // }

  // loadSales() {
  //   const newData = [99, 99, 99, 38, 15, 30, 35, 28, 8]
  //   this.updateColumnChartData(newData);
  //   console.log('Loading Sales Data...');
  // }

  modalOpenDefault(modalDefault) {
    this.modalService.open(modalDefault, {
      centered: true
    });
  }

  downloadFile(file: string){
    if(file == 'pdf'){
      let tableHTML = `
        <html>
          <head>
            <title>Table Export</title>
            <style>
              table { width: 100%; border-collapse: collapse; font-size: 14px; direction: rtl; }
              th, td { border: 1px solid black; padding: 8px; text-align: center; }
              th { background-color: #f2f2f2; }
            </style>
          </head>
          <body>
            <h2 style="text-align:center;">تقرير الجدول</h2>
            <table>
              <thead>
                <tr>
                  ${Object.keys(this.rows[0]).map(header => `<th>${header}</th>`).join("")}
                </tr>
              </thead>
              <tbody>
                ${this.rows.map(row => `
                  <tr>
                    ${Object.keys(row).map(key => `<td>${row[key].toString().replace(/<[^>]*>/g, '')}</td>`).join("")}
                  </tr>
                `).join("")}
              </tbody>
            </table>
          </body>
        </html>
      `;

      const newWindow = window.open("", "_blank");
      newWindow?.document.write(tableHTML);
      newWindow?.document.close();
      newWindow?.print();
    }else if(file == 'excel'){
      if (!this.rows || this.rows.length === 0) {
        alert("لا توجد بيانات للتصدير!");
        return;
      }
    
      let csvContent = "\uFEFF"; // UTF-8 BOM for Arabic compatibility
    
      // Extract column headers dynamically from the first row
      const headers = Object.keys(this.rows[0]); 
      csvContent += headers.join(",") + "\n";
    
      // Add Table Rows
      this.rows.forEach(row => {
        const rowData = headers.map(header => {
          let cell = row[header] ? row[header].toString() : '';
          return `"${cell.replace(/"/g, '""').replace(/<[^>]*>/g, '')}"`; // Escape quotes & remove HTML
        }).join(",");
        csvContent += rowData + "\n";
      });
    
      // Create a Download Link
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.setAttribute("download", "Last_Orders.csv");
      document.body.appendChild(link);
    
      // Trigger Click
      link.click();
      document.body.removeChild(link);
    }
  }
  // public kitchenSinkRows: any;
  // // public basicSelectedOption: number = 10;
  // // public SelectionType = SelectionType;
  // filterUpdate(event) {
  //   const val = event.target.value.toLowerCase();

  //   // filter our data
  //   const temp = this.tempData.filter(function (d) {
  //     return d.full_name.toLowerCase().indexOf(val) !== -1 || !val;
  //   });

  //   // update the rows
  //   this.kitchenSinkRows = temp;
  //   // Whenever the filter changes, always go back to the first page
  //   this.table.offset = 0;
  // }

  export(){
    const headers = {
      paymentId: 'Payment ID',
      orderId: 'Order ID',
      totalAmount: 'Total Amount',
      paymentWay: 'Payment Provider',
      paymentStatus: 'Payment Status',
      paidAt: 'Paid At',
    };
    this.excelService.exportExcel('تقرير المستخدمين',this.rows,headers)
  }

}
